/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FishbrainExportStartResponse
 */
export interface FishbrainExportStartResponse {
    /**
     * 
     */
    flowRunId: string;
}

/**
 * Check if a given object implements the FishbrainExportStartResponse interface.
 */
export function instanceOfFishbrainExportStartResponse(value: object): value is FishbrainExportStartResponse {
    if ((!('flowRunId' in (value as Record<string, any>)) && !('flow_run_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['flowRunId'] === undefined && (value as Record<string, any>)['flow_run_id'] === undefined)) return false;
    return true;
}

export function FishbrainExportStartResponseFromJSON(json: any): FishbrainExportStartResponse {
    return FishbrainExportStartResponseFromJSONTyped(json, false);
}

export function FishbrainExportStartResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FishbrainExportStartResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'flowRunId': json['flow_run_id'],
    };
}

export function FishbrainExportStartResponseToJSON(json: any): FishbrainExportStartResponse {
    return FishbrainExportStartResponseToJSONTyped(json, false);
}

export function FishbrainExportStartResponseToJSONTyped(value?: FishbrainExportStartResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'flow_run_id': value['flowRunId'],
    };
}

